(function (appComponents) {

	appComponents.controllers.quoteCheckout = function (Components) {
		var quoteCheckout = {};

		quoteCheckout.name = "quoteCheckout";

		Components.getControllerPrototype().extend(quoteCheckout);

		quoteCheckout._cart = quoteCheckout._getService("cartBase");
		quoteCheckout._b2bUnit = quoteCheckout._getService("b2bUnit");
		quoteCheckout._panda = quoteCheckout._getService("panda");
		quoteCheckout._modals = quoteCheckout._getService("modals");
		quoteCheckout._helpers = quoteCheckout._getService("helpers");
		quoteCheckout._quotes = quoteCheckout._getService("quotesBase");
		quoteCheckout._cartCheckout = quoteCheckout._getService("cartCheckout");
		
		quoteCheckout.stepRunning = false;

		quoteCheckout.elements = {
			get reviewStep() {
				return $('[pc-container="quote-checkout--review-step"]');
			},
			get confirmStep() {
				return $('[pc-container="quote-checkout--confirm-step"]');
			},
			get goToConfirmAcc() {
				return $('[pc-container="quote-checkout--go-to-confirm-acc"]');
			},
			get goToReviewAcc() {
				return $('[pc-container="quote-checkout--go-to-review-acc"]');
			}
		};

		quoteCheckout.bindings = function () {
			quoteCheckout._elements.page.on("ifChecked", "input[name='quoteForCustomer'][value='true']", function () {
				$(".cus-quo-info").removeClass('dis-none');
			});

			quoteCheckout._elements.page.on("ifChecked", "input[name='quoteForCustomer'][value='false']", function () {
				$(".cus-quo-info").addClass('dis-none');
			});
			quoteCheckout._elements.page.on("change", "#my-file-selector", function () {
				var pathname = $(this).val();
				var filename = pathname.split(/(\\|\/)/g).pop();
				$("#upload-file-info").text(filename);
			});
			quoteCheckout._elements.page.on("click", '[pc-container="quote-checkout--panda-more-info"]', function () {
				var entryNumber = $(this).parents('[pc-container="quote-checkout--item"]').attr("pc-value");
				quoteCheckout.handlers.onPandaMoreInfo(entryNumber);
			});
			quoteCheckout._elements.page.on("click", '[pc-container="quote-checkout--go-to-confirm-btn"]', function () {

				quoteCheckout.handlers.onGoToConfirm();
			});
			quoteCheckout._elements.page.on("click", '[pc-container="quote-checkout--go-to-review-btn"]', function () {

				var form = $("[pc-container='quote-checkout--customer-quote-form']")[0];
				quoteCheckout.handlers.onGoToReview(form);
			});

			quoteCheckout._elements.page.off('click', '.acc-wizard-todo>a').on('click', '.acc-wizard-todo>a', function (e) {
				e.preventDefault();
			});

		};
	      
		quoteCheckout.liveBindings = function () {
			// from td
			$("input#my-quote").on("ifChecked", function () {
				$(".my-quo-info").removeClass('dis-none');
				$(".quote-check").on("click", function () {
					$(".cust-infor").addClass("dis-none");
				});
			});

			$("input#my-quote").on("ifUnchecked", function () {
				$(".my-quo-info").addClass('dis-none');
				$(".quote-check").on("click", function () {
					$(".cust-infor").removeClass("dis-none");
				});
			});

			$(".quote-check").off().click(function () {
				$(this).parents(".panel-default").find(".circle-gray").addClass("active").html("<i class='fa fa-check'></i>");
				$(".wizard-quote").addClass("active");
				$("#ship-heading").find(".circle-gray").addClass("active");
			});

			$(".review-q-check").off().click(function () {
				$(this).parents(".panel-default").find(".circle-gray").addClass("active").html("<i class='fa fa-check'></i>");
				$(".wizard-review-quote").addClass("active");
				$("#quote-review").removeClass("in");
				$("#headingThree").find(".circle-gray").addClass("active");
			});
			$("#my-file-selector").on("change", function(){
				var size = this.files[0].size; // file size
				console.log("size",size);
			    var extn = this.value.lastIndexOf('.') + 1; // index of file format
			    var format = this.value.substring(extn); // file format
			    switch(format)
			    {
			        case 'jpg':
			        case 'bmp':
			        case 'png':
			        case 'tif':
			            if(size > 10000000){// if more than 10MB
			            	quoteCheckout._modals.error.show("Please upload logo with the size not exceeding 10 MB");
			            	this.value='';
			            }
			            break;
			        default:
			        	quoteCheckout._modals.error.show("Please upload logo in the format of *.jpeg, tiff, png or gif");
			            this.value='';
			    }

			});
		};

		quoteCheckout.populateShippingAddresses = function () {
			return quoteCheckout._api.b2bUnit.getShippingAddresses().then(function (res) {
				if (res && res.status == 200) {
					quoteCheckout.context.shippingAddresses = res.body;
				} else {
					console.log(res);
				}
			});
		};

		quoteCheckout.populateBillingAddresses = function () {
			return quoteCheckout._api.b2bUnit.getBillingAddresses().then(function (res) {
				if (res && res.status == 200) {
					quoteCheckout.context.billingAddresses = res.body;
				}
			}).fail(function (e) {
				console.log(e);
			});
		};

		quoteCheckout.populateInitialContext = function () {
			var defToReturn = $.Deferred();

			quoteCheckout.context.unitType = quoteCheckout._b2bUnit.currentUnit.unitType;
			quoteCheckout.context.unit = quoteCheckout._b2bUnit.currentUnit;

			if (quoteCheckout.context.unitType == "SAP" || quoteCheckout.context.unitType == "GRID") {
				var defShipping = quoteCheckout.populateShippingAddresses();
				var defBilling = quoteCheckout.populateBillingAddresses();
				$.when(defShipping, defBilling).then(function () {
					defToReturn.resolve();
				});
			} else {
				defToReturn.resolve();
			}
			return defToReturn;
		};

		quoteCheckout.renderReviewStep = function () {
			var html = quoteCheckout.templates.reviewStep(quoteCheckout.context);
			quoteCheckout.elements.reviewStep.html(html);
		};

		quoteCheckout.renderConfirmStep = function () {
			var html = quoteCheckout.templates.confirmStep(quoteCheckout.context);
			quoteCheckout.elements.confirmStep.html(html);
		};

		quoteCheckout.handlers = {
			onPandaMoreInfo: function (entryNumber) {
				var entry = null;
				quoteCheckout.context.entries.forEach(function (el) {
					if (el.entryNumber == entryNumber) {
						entry = el;
					}
				});
				quoteCheckout._panda.showDetails(entry);
			},
			onB2bUnitChanged: function () {
				if (quoteCheckout._isActiveController) {
					quoteCheckout.init();
				}
			},
			onGoToReview: function (form) {
				if (quoteCheckout.stepRunning) return;

				quoteCheckout.stepRunning = true;

				var hasErrors = quoteCheckout._helpers.checkFormForErrors(form);

				if (hasErrors) {
					quoteCheckout._modals.error.show(quoteCheckout._messages.formError);
					quoteCheckout.stepRunning = false;
					return false;
				}

				var customerQuoteFormData = new FormData(form);

				var customerQuoteData = quoteCheckout._utils.getFormData(form);

				quoteCheckout.context.flags.isCustomerQuote = customerQuoteData.quoteForCustomer;

				for (var prop in customerQuoteData) {
					var newProp = prop.substring(prop.indexOf(".") + 1);
					customerQuoteData[newProp] = customerQuoteData[prop];
					delete customerQuoteData[prop];
				}

				quoteCheckout._api.quoteCheckout.saveAndReviewQuote(customerQuoteFormData).then(function (res) {
					if (res && res.status == 200) {
						quoteCheckout._api.quoteCheckout.reviewQuote().then(function (res) {
							if (res && res.status == 200) {
								quoteCheckout.context.customerQuoteData = customerQuoteData;

								quoteCheckout.context.quoteData = res.body.quoteData;

								// quoteCheckout.context.cartPaymentAddress = res.body.cartPaymentAddress;
								quoteCheckout.context.approverAddress = res.body.approverAddress;
								quoteCheckout.context.contactInformation = res.body.contactInformation;

								quoteCheckout.context.entries = res.body.quoteData.entries;
								quoteCheckout.context.kits = res.body.productAccessoriesRelation;

								quoteCheckout.renderReviewStep();

								quoteCheckout.elements.goToReviewAcc.click();

								quoteCheckout._applyScript.niceScroll();
							} else {
								console.log(res.status);
							}
						});
					} else {
						quoteCheckout._modals.error.show(res.message);
						console.log(res);
					}
				}).fail(function (e) {
					//quoteCheckout._modals.error.show(quoteCheckout._messages.serverError);
					console.log(e);
				}).always(function () {
					quoteCheckout.stepRunning = false;
				});

			},
			onGoToConfirm: function () {
				if (quoteCheckout.stepRunning) return;

				quoteCheckout.stepRunning = true;


				quoteCheckout._quotes.confirmQuoteCreation().then(function (res) {
					// quoteCheckout._api.quoteCheckout.confirmQuote().then(function (res) {
					if (res && res.status == 200) {
						quoteCheckout.context.quoteData = res.body.orderData;
						quoteCheckout.renderConfirmStep();
						quoteCheckout.elements.goToConfirmAcc.click();
						quoteCheckout._events.dispatchEvent("quoteCreated");
					}
				}).fail(function (e) {
					console.log(e);
				}).always(function () {
					quoteCheckout.stepRunning = false;
				});
			},
		};
		
		quoteCheckout.init = function () {

			quoteCheckout._api.quoteCheckout.checkoutQuote().then(function (res) {
				if (res && res.status == 200) {
					$("body > div.modal-backdrop.fade.in").hide();
					quoteCheckout._cart.getCartItems().then(function () {

						quoteCheckout.populateInitialContext().then(function () {

							quoteCheckout._renderPageTemplate();

							quoteCheckout._bindings();

							quoteCheckout._applyScript.base.accWizard();

							quoteCheckout._helpers.populateCountries();

							quoteCheckout._events.dispatchEvent("controllerInitialized");

							quoteCheckout._events.registerHandler("b2bUnitChanged", quoteCheckout.name, quoteCheckout.handlers.onB2bUnitChanged);

						});

					}).fail(function (e) {
						console.log(e);
					});
							
				} else if(res && res.status == 406){
					//$("body > div.modal-backdrop.fade.in").show();
					$('[pc-container="cart--item-kit-error'+res.body+'"]').show();
					window.history.replaceState({}, null, window.location.origin+"/rmstorefront/shopping-cart");
					app.router.writeHistory("push","/rmstorefront/shopping-cart", "");
					quoteCheckout._cartCheckout.showForQuote();
				}
				else 
				{
					window.history.replaceState({}, null, window.location.origin+"/rmstorefront/shopping-cart");
					app.router.writeHistory("push","/rmstorefront/shopping-cart", "");
					quoteCheckout._modals.error.show(res.message);
				}
			}).fail(function (e) {
				//quoteCheckout._modals.error.show(quoteCheckout._messages.serverError);
				console.log(e);
			});
			
		};

		return quoteCheckout;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});